import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { ADMIN_TABS, PHARMACIEN_TABS, SUPER_ADMIN_TABS, TAB_QUERY_KEYS } from "./adminDashboard/adminConstants";
import { EhpadsTab } from "./adminDashboard/ehpads/EhpadsTab";
import { MaintenanceTab } from "./adminDashboard/maintenance/MaintenanceTab";
import { TherapeuticBookTab } from "./adminDashboard/therapeutic/TherapeuticBookTab";
import { TourneesTab } from "./adminDashboard/tournees/TourneesTab";
import { UsersTab } from "./adminDashboard/users/UsersTab";

export default function AdminDashboard() {
    const { user, selectedPharmacy } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const isSuperAdmin = user?.role === "SUPER_ADMIN";
    const isPharmacien = user?.role === "PHARMACIEN";
    const tabs = isPharmacien ? PHARMACIEN_TABS : isSuperAdmin ? SUPER_ADMIN_TABS : ADMIN_TABS;
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        const requestedTab = new URLSearchParams(location.search || "").get("tab");
        if (requestedTab === "planning-livraison") {
            navigate("/bon-livraison/planning", { replace: true });
            return;
        }
        if (!requestedTab) {
            setActiveTab(0);
            return;
        }
        const tabIndex = tabs.findIndex(tab => TAB_QUERY_KEYS[tab] === requestedTab);
        setActiveTab(tabIndex >= 0 ? tabIndex : 0);
    }, [location.search, navigate, tabs]);

    if (isSuperAdmin && !selectedPharmacy) {
        return (
            <div style={{ padding: "60px 32px", maxWidth: "600px", margin: "0 auto", textAlign: "center" }}>
                <div style={{ fontSize: "40px", marginBottom: "16px" }}>🏥</div>
                <h2 style={{ fontSize: "20px", fontWeight: 700, color: "#111827", marginBottom: "12px" }}>
                    Sélectionnez une pharmacie
                </h2>
                <p style={{ fontSize: "14px", color: "#6b7280", lineHeight: 1.6 }}>
                    En tant que Super Admin, vous devez sélectionner une pharmacie dans le menu de gauche
                    avant de pouvoir accéder à son administration.
                </p>
            </div>
        );
    }

    const renderTab = (tabName) => {
        switch (tabName) {
            case "Utilisateurs": return <UsersTab />;
            case "EHPADs":      return <EhpadsTab />;
            case "Tournées":    return <TourneesTab />;
            case "Livret thérapeutique": return <TherapeuticBookTab />;
            case "Maintenance": return <MaintenanceTab />;
            default:            return null;
        }
    };

    const handleTabClick = (tab, index) => {
        setActiveTab(index);
        const tabKey = TAB_QUERY_KEYS[tab];
        const target = tabKey ? `/informations?tab=${tabKey}` : "/informations";
        const current = `${location.pathname}${location.search || ""}`;
        if (current !== target) navigate(target, { replace: true });
    };

    return (
        <div style={{ minHeight: "100%", background: "#f0eeeb" }}>
            <div style={{ maxWidth: "960px", margin: "0 auto", padding: "40px 32px" }}>

                {/* ── En-tête ─────────────────────────────────────────────── */}
                <h1 style={{ fontSize: "28px", fontWeight: 700, color: "#111827", margin: 0, marginBottom: "6px" }}>
                    Informations
                </h1>
                <p style={{ fontSize: "14px", color: "#6b7280", margin: 0, marginBottom: "28px" }}>
                    Gérez les accès, les EHPADs, les tournées, le livret thérapeutique et la maintenance de la plateforme.
                </p>

                {/* ── Onglets ─────────────────────────────────────────────── */}
                <div style={{ display: "flex", borderBottom: "1.5px solid #e5e7eb", marginBottom: "28px" }}>
                    {tabs.map((tab, i) => (
                        <button
                            key={tab}
                            onClick={() => handleTabClick(tab, i)}
                            style={{
                                padding: "10px 20px",
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: activeTab === i ? 600 : 400,
                                color: activeTab === i ? "#6c4de6" : "#6b7280",
                                borderBottom: activeTab === i ? "2px solid #6c4de6" : "2px solid transparent",
                                marginBottom: "-1.5px",
                                transition: "color 0.15s",
                            }}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {renderTab(tabs[activeTab])}
            </div>
        </div>
    );
}
